const Button = ({ icon, title, isDisabled, onClick, color, customClass = '', customSpanClass = '', badgeNumber }) => {
    return (
        <button className={`btn-header ${isDisabled ? "inactive" : ""} ${customClass}`} onClick={onClick}>
          { icon && <i className={`fa-light ${icon}`} style={{color:color}}/> }
          <span className={`${customSpanClass}`}>{title}</span>

          {badgeNumber > 0 && (
              <span 
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '6px',
                  backgroundColor: '#f89624',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '0.2rem 0.5rem',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  lineHeight: 1,
                  userSelect: 'none',
                  minWidth: '18px',
                  textAlign: 'center',
                  boxSizing: 'border-box',
                  pointerEvents: 'none',
                }}
              >
                  {badgeNumber}
              </span>
          )}
      </button>
    );
};

export default Button;
